import { render, staticRenderFns } from "./DashboardWaitingPlanItems.vue?vue&type=template&id=29c7152e"
import script from "./DashboardWaitingPlanItems.vue?vue&type=script&lang=ts"
export * from "./DashboardWaitingPlanItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports